//将拦截器整体导入
import request from '@/api/index'//导入已经写好的拦截器
 
// 封装所有的API接口
 
export function Test(){
//   console.log(params)
  return request({
    url:'/test/test1',
    method :'get'
  })
}
 
//根据公司业务类型获取列表
export function companyServiceList(type){
  //   console.log(params)
    return request({
      url:'/companyServiceList/'+type,
      method :'get'
    })
  }


//联系我们
export function contactUsList(){
  //   console.log(params)
    return request({
      url:'/contactUsList',
      method :'get'
    })
  }

  
//关于我们
export function regardingUsList(type){
  //   console.log(params)
    return request({
      url:'/regardingUsList/'+type,
      method :'get'
    })
  }


  //职位列表
export function workPositionList(){
  //   console.log(params)
    return request({
      url:'/workPositionList/',
      method :'get'
    })
  }

  
  //职位详情
export function workPositionInfo(id){
  //   console.log(params)
    return request({
      url:'/workPosition/info/'+id,
      method :'get'
    })
  }

  


   
// 文件上传
export function uploadFile(file) {
  const formData = new FormData()
  formData.append('file', file)
  return request({
    url: '/upload',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

// 提交职位申请
export function submitJobApplication(data) {
  return request({
    url: '/saveAttachment',
    method: 'post',
    data
  })
}

//首页信息
export function homeList(){
  //   console.log(params)
    return request({
      url:'/homeList/',
      method :'get'
    })
  }


// 统一导出所有API函数
export default {
    Test,
    companyServiceList,
    contactUsList,
    regardingUsList,
    workPositionList,
    workPositionInfo,
    uploadFile,
    submitJobApplication,
    homeList
}


// WEBPACK FOOTER //
// ./src/api/api.js